module.exports = __webpack_public_path__ + "media/images/download-regular-e35a6cb5.svg";